<div
  class="alert alert-{{ type }}"
  role="alert"
  [attr.aria-live]="type === 'danger' ? 'assertive' : 'polite'"
  [attr.aria-atomic]="true"
  [attr.aria-relevant]="'all'"
  [attr.aria-label]="'Alert: ' + (type | titlecase)"
  [attr.tabindex]="type === 'danger' ? '0' : '-1'"
>
  <div
    class="alert-content"
  >
    {{ isAlertMessageTranslated ? (message | translate) : message }}
  </div>
</div>